import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-reporting }}\n{{ghost-text 90}}",{ moduleName: "embercom/components/reporting/empty-state/ghost-field.hbs" })